<template>
  <div>
    <div v-if="loading" class="loading">
      <SvgLoaderMoon> </SvgLoaderMoon>
    </div>
    <div v-if="!loading">
      <!-- Content part -->

      <div class="company-user__content">
        <div class="company-user__user-info">
          <UsersShow :showDeleteUser="true" :disableAllowLogin="false" @set_user="setUser($event)"> </UsersShow>
        </div>

        <div v-if="user" class="company-user__user-roles">
          <div class="row">
            <div class="col-sm-12">
              <RolesIndex
                :roles="user.roles"
                :obj="user"
                :obj_name="user_full_name"
                :roles_for_select="roles_for_select"
                @removeRole="removeRole($event)"
                @addRole="addRole($event)"
              >
              </RolesIndex>
            </div>
          </div>
        </div>
      </div>

      <!-- End Content part -->
    </div>
  </div>
</template>

<script>
import UsersShow from '../users/UsersShow';
import axiosAuth from '../../../axiosMain';
import RolesIndex from '../roles/RolesIndex';
import BackButton from '../../../components/buttons/BackButton';
import SvgLoaderMoon from '../../../components/svg/SvgLoaderMoon';

export default {
  name: 'CompanyUserShow',
  components: { BackButton, RolesIndex, UsersShow, SvgLoaderMoon },
  data: function () {
    return {
      user: null,
      roles_for_select: {},
      loading: true,
      user_full_name: '',
    };
  },
  computed: {
    auth_user() {
      return this.$store.getters.user;
    },
  },
  mounted() {
    this.getCompanyRolesWithoutAlreadyTakeRoles();
  },
  methods: {
    setUser: function (event) {
      this.user = event;
      this.user_full_name = this.user.first_name + ' ' + this.user.last_name;
    },
    removeRole: function (event) {
      axiosAuth
        .post(
          '/users_roles/delete',
          {
            user_id: this.user.user_id,
            role_id: event.data.role_id,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.user = response.data.data;
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('The_role_was_removed'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data[0],
          });
        });
    },
    addRole: function (event) {
      axiosAuth
        .post(
          '/users_roles',
          {
            user_id: this.user.user_id,
            roles: [
              {
                role_id: event.role_id,
              },
            ],
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.user = response.data.data;
          this.$notify({
            type: 'success',
            text: this.$t('the_new_role_was_assigned'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'danger',
            title: errors.response.data.errors.role_id[0],
          });
        });
    },
    getCompanyRolesWithoutAlreadyTakeRoles: function () {
      axiosAuth
        .get('/company_roles/' + this.auth_user.company.data.company_id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          this.roles_for_select = response.data.data;
          this.loading = false;
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data,
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
